import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import extendClassName from '../../../lib/bemUtils/bem';
import { TextMarker } from '../../../_lib/components/TextMarker/TextMarker';

export function TextSnippet({ text, modifier }: { text: string; modifier?: 'collapsible' }) {
  const { t } = useSonTranslation('SearchResultTeaser');
  // replace all '...' by &hellip;
  const content = text.replaceAll('...', '\u2026');

  return (
    <p className={extendClassName('search-result-teaser__text', modifier)}>
      <dfn className="invisible">{t('textSnippet')}: </dfn>
      <TextMarker text={content} />
    </p>
  );
}
